"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeTokens = normalizeTokens;

function normalizeTokens(tokens) {
  return {
    idToken: tokens.id_token,
    refreshToken: tokens.refresh_token
  };
}